<mat-dialog-content>
    <h3 *ngIf="data?.title">{{data?.title}}</h3>
    
    <p *ngIf="data?.is_expired_token">
        {{ 'MESSAGE_DIALOG.EXPIRES_IN' | translate }}
        <span>{{ countdownTimer }}</span>
        {{ 'MESSAGE_DIALOG.MINUTE_LEFT' | translate }}
    </p>
    <p>{{ 'MESSAGE_DIALOG.TOKEN_EXPIRED' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin-bottom: 0px;">
    <button class="m-r-10" mat-button [mat-dialog-close]="false">
        <mat-icon>close</mat-icon> {{ 'MESSAGE_DIALOG.BTN_NO' | translate }}
    </button>
    <button class="next-button" mat-raised-button [mat-dialog-close]="true">
        <mat-icon>check</mat-icon> {{ 'MESSAGE_DIALOG.BTN_YES' | translate }}
    </button>
</mat-dialog-actions>